import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import '../../sass/components/flexibleModules/_components.fullWidthReviewSection.scss';

const FullWidthReviewSection = ({ data }) => {
    return (
        <div className={`cp-flexibleFullWidthReview l--genericpadding l--sectionPadding ${data.layoutSelection} l-${data.textColor}`} style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-flexibleFullWidthReview__inner l--flex" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                <div className="cp-flexibleFullWidthReview__left" style={{ backgroundColor: `${data.fullWidthReviewSectionSectionBackground}` }}>
                    {data.fullWidthReviewSectionStarRating &&
                        <GatsbyImage image={getImage(data.fullWidthReviewSectionStarRating.gatsbyImage)} alt={data.fullWidthReviewSectionStarRating.altText} />
                    }
                    {data.fullWidthReviewSectionTeaser &&
                        <p dangerouslySetInnerHTML={{ __html: data.fullWidthReviewSectionTeaser }} />
                    }
                    {data.fullWidthReviewSectionAuthorName &&
                        <span>{data.fullWidthReviewSectionAuthorName}</span>
                    }
                    {data.fullWidthReviewSectionAuthorTitle &&
                        <span>{data.fullWidthReviewSectionAuthorTitle}</span>
                    }
                    {data.fullWidthReviewSectionCustomerStoryLink &&
                        <a href={data.fullWidthReviewSectionCustomerStoryLink.url} target={data.fullWidthReviewSectionCustomerStoryLink.target}>{data.fullWidthReviewSectionCustomerStoryLink.title}</a>
                    }
                </div>
                <div className="cp-flexibleFullWidthReview__right">
                    {data.fullWidthReviewSectionAuthorImage &&
                        <GatsbyImage image={getImage(data.fullWidthReviewSectionAuthorImage.gatsbyImage)} alt={data.fullWidthReviewSectionAuthorImage.altText} />
                    }
                    {data.fullWidthReviewSectionReviewVideo === 'yes' &&
                        <a href="/">Video embed</a>
                    }
                </div>
            </div>
        </div>
    );
}

export default FullWidthReviewSection;